module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/666cc9d42862c4dedf91e0885ad79267.png";